const getApiBaseUrl = () => {
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL
  return ''
}

export const API_BASE_URL = getApiBaseUrl()

// 图片 URL 统一转为 dlsy.space Pages Functions 代理路径
export const getImageUrl = (url: string): string => {
  if (!url) return url
  // 已经是代理 URL，保持
  if (url.startsWith('https://dlsy.space/api/images/')) return url
  // 相对路径补全
  if (url.startsWith('/api/images/')) return `https://dlsy.space${url}`
  // 老的 dlsy.space 直连 URL → 转为代理路径（dlsy.space 已不再直连 R2）
  if (url.startsWith('https://dlsy.space/')) {
    const key = url.replace('https://dlsy.space/', '')
    return `https://dlsy.space/api/images/${key}`
  }
  // R2.dev 直连 URL → 转为代理路径
  const r2Match = url.match(/^https:\/\/[a-z0-9-]+\.r2\.dev\/(.+)$/)
  if (r2Match) {
    return `https://dlsy.space/api/images/${r2Match[1]}`
  }
  return url
}
